export default __webpack_public_path__ + "static/media/result-shedding.857bcbe7.svg";